export { default as KAvatar } from './KAvatar.vue'
export { default as KBanner } from './KBanner.vue'
export { default as KButton } from './KButton.vue'
export { default as KCard } from './KCard.vue'
export { default as KCategory } from './KCategory.vue'
export { default as KDropdown } from './KDropdown.vue'
export { default as KIconButton } from './KIconButton.vue'
export { default as KInput } from './KInput.vue'
export { default as KMarketplaceCard } from './KMarketplaceCard.vue'
export { default as KOfferCard } from './KOfferCard.vue'
export { default as KProductCard } from './KProductCard.vue'
export { default as KSearch } from './KSearch.vue'
export { default as KSelectionButton } from './KSelectionButton.vue'
export { default as KTag } from './KTag.vue'
export { default as Like } from './Like.vue'
export { default as ShowPassword } from './ShowPassword.vue'
export { default as KIcon } from './KIcon.vue'



// WEBPACK FOOTER //
// ./src/components/KaledoComponents/index.js